<template>
    <div v-if="isSuccess" class="notification is-success is-light">
        <span class="icon">
            <i class="fas fa-check-circle"></i>
        </span>
        <p>Password reset email sent successfully.</p>
        <p>Please check your <b>spam folder</b> as well.</p>
    </div>
    <div v-else>
        <a class="has-text-link" @click="resetPassword" style="cursor: pointer;">Forgot password?</a>
    </div>
    <div v-if="error" class="notification is-danger is-light">
        <span class="icon">
            <i class="fas fa-exclamation-triangle"></i>
        </span>
        {{error}}
    </div>
</template>

<script>
import { auth } from "@/firebase/firebaseInit";
import { sendPasswordResetEmail } from "@firebase/auth";
export default {
    props: ['email'],
    data() {
        return {
            isSuccess: false,
            error: null
        }
    },
    methods: {
        validEmail(email) {
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        resetPassword() {
            this.isSuccess = false;
            this.error = null;
            if (!this.validEmail(this.email)) {
                this.error = "Oops! Please enter a valid email address to reset your password."
            } else {
                sendPasswordResetEmail(auth, this.email)
                    .then(() => {
                        this.isSuccess = true;
                    }).catch(() => {
                        this.error = "Are you sure that's the correct email? Try again or contact an Apexian.";
                    })
            }
        }
    },
    watch: {
        email: function () {
            this.error = null;
        }
    }
}
</script>